<template>
  <v-row dense no-gutters>
    <v-col cols="12">
      <v-card class=" mt-1 fill-height">
        <v-tabs v-model="currTab" @change="tabChanged" class="fill-height">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab v-for="tab in tabs" :key="tab.key" :disabled="!project.ULF_ID && tab.key !== 'tabProject'"> {{ tab.label }} <v-icon small right> {{tab.icon}} </v-icon> </v-tab>
          <v-tab-item v-for="tab in tabs" :key="tab.key" >
            <component :is="tab.tab_component" :project="localProject" :activeTab="tabKey" @onChange="tab.onChangeHandler"></component>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
    <info-dialog :message="'Не задано имя проекта!'" v-model="infoShow"/>
  </v-row>
</template>

<script>
import { RCPT_CREATE_RECEPTURE, RCPT_UPDATE } from '@/store/actions/receptures'
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import projectCard from '@/components/modules/projects/cards/configuration/projectCard.vue'
import ProjectPropertiesCard from '@/components/modules/projects/cards/configuration/projectPropertiesCard.vue'
import ProjectComponentsCard from '@/components/modules/projects/cards/configuration/projectComponentsCard.vue'
import ProjectCPCombinedCard from '@/components/modules/projects/cards/configuration/projectCPCombinedCard.vue'
import ProjectDialogCard from '@/components/modules/projects/cards/configuration/projectDialogCard.vue'
import ProjectRouteCard from '@/components/modules/projects/cards/configuration/projectRouteCard.vue'

export default {
  name: 'sysProjectEditor',
  components: {
    ProjectComponentsCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/cards/configuration/projectComponentsCard'),
    ProjectPropertiesCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/cards/configuration/projectPropertiesCard'),
    ProjectCPCombinedCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/cards/configuration/projectCPCombinedCard'),
    projectCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/cards/configuration/projectCard'),
    InfoDialog: () => import(/* webpackChunkName: "commonUI" */ '@/components/common/dialogs/infoDialog.vue'),
    ProjectDialogCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/cards/configuration/projectDialogCard'),
    ProjectRouteCard: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/cards/configuration/projectRouteCard')
  },
  data () {
    return {
      tabs: [
        { key: 'tabProject', tab_component: projectCard, label: 'Общие данные', icon: '', onChangeHandler: this.projectDataChange },
        { key: 'tabProperties', tab_component: ProjectPropertiesCard, label: 'Свойства', icon: '', onChangeHandler: this.projectDataChange },
        { key: 'tabComponents', tab_component: ProjectComponentsCard, label: 'Компоненты', icon: '', onChangeHandler: this.projectDataChange },
        { key: 'tabCPCombined', tab_component: ProjectCPCombinedCard, label: 'Сводная таблица', icon: '', onChangeHandler: this.projectDataChange },
        { key: 'tabDialog', tab_component: ProjectDialogCard, label: 'Переписка', icon: '', onChangeHandler: this.projectDialogChange },
        { key: 'tabRoute', tab_component: ProjectRouteCard, label: 'Маршрут', icon: '', onChangeHandler: this.projectRouteChange }
      ],
      saveAction: { text: 'Сохранить конфигурацию', actionType: 'Конфигурация', action: 'saveNewEvent', method: this.saveProject, icon: 'mdi-newspaper-plus', params: '' },
      updAction: { text: 'Обновить конфигурацию', actionType: 'Конфигурация', action: 'updEvent', method: this.updProject, icon: 'mdi-newspaper-check', params: '' },
      closeViewer: { text: 'Завершить просмотр', actionType: 'Конфигурация', action: 'closeEventView', method: this.closeProject, icon: 'mdi-window-close', params: '' },
      localProject: {},
      currTab: 0,
      activeTab: '',
      infoShow: false
    }
  },
  computed: {
    project: {
      get () {
        return this.$store.getters.getCurrentRecepture
      }
    },
    tabKey: {
      get: function () {
        return this.tabs[this.currTab].key
      }
    }
  },
  watch: {
    project (val) {
      console.log('projectEditor:: watcher detected project changed', val)
      this.resetLocal(val)
    }
  },
  methods: {
    resetLocal (val) {
      if (val && val.ULF_ID) {
        console.log('projectEditor:: Cloning current recepture')
        // eslint-disable-next-line no-undef
        this.localProject = structuredClone(val)
      } else {
        console.log('projectEditor:: Clearing current recepture')
        this.localProject = {}
      }
      this.setActions()
    },
    tabChanged (val) {
      console.log('Current tab is ', this.currTab)
      this.setActions()
    },
    dataValid () {
      const clearName = this.localProject.ULF_NAME ? this.localProject.ULF_NAME.trim() : ''
      const nameOK = clearName.length > 0
      const codeOK = this.localProject.ULF_CODE ? this.localProject.ULF_CODE.trim().length > 0 : false
      const gradeOK = this.localProject.GRADE
      return nameOK && gradeOK && codeOK
    },
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Конфигурация', actions: [] })
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Свойства', actions: [] })
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Компоненты', actions: [] })
      if (this.localProject.ULF_ID) {
        if (this.dataValid()) this.$store.dispatch(UI_ADD_ACTION, this.updAction)
      } else {
        if (this.dataValid()) this.$store.dispatch(UI_ADD_ACTION, this.saveAction)
      }
      this.$store.dispatch(UI_ADD_ACTION, this.closeViewer)
    },
    saveProject () {
      console.log('projectEditor:: Trying to save', this.localProject)
      if (!this.localProject.ULF_CODE) return
      if (!this.dataValid()) {
        this.infoShow = true
        return
      }
      const self = this
      this.$store.dispatch(RCPT_CREATE_RECEPTURE, this.localProject)
        .then((resp) => {
          console.log('projectEditor:: Saved success ', resp)
          // this.$router.push({ path: '/projects/project', query: { reqid: self.currentProject.ULF_ID } })
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    },
    updProject () {
      console.log('projectEditor:: Trying to update', this.localProject)
      if (!this.dataValid()) {
        this.infoShow = true
        return
      }
      console.log('data is valid', this.localProject)
      const self = this
      this.$store.dispatch(RCPT_UPDATE, this.localProject)
        .then((resp) => {
          console.log('projectEditor:: Update success ', resp)
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    },
    closeProject () {
      console.log('projectEditor:: Trying to close')
      this.$router.push('/projects/myprojects')
    },
    projectDataChange (prj) {
      console.log('projectEditor:: projectChange method called ', prj)
      if (this.currTab) {
        console.log('projectEditor:: projectChange restructuring ', prj)
        // eslint-disable-next-line no-undef
        let tmp = structuredClone(this.localProject)
        tmp = { ...tmp, ...prj }
        this.localProject = tmp
      } else {
        console.log('projectEditor:: projectChange flat change ', prj)
        this.localProject = { ...this.localProject, ...prj }
      }
      console.log('projectEditor:: projectChange current data is ', this.localProject)
      this.setActions()
    },
    projectRouteChange (prj) {
      console.log('projectEditor:: projectRouteChange method called ', prj)
      console.log('projectEditor:: projectChange current data is ', this.localProject)
      this.setActions()
    },
    projectDialogChange (prj) {
      console.log('projectEditor:: projectDialogChange method called ', prj)
      this.setActions()
    },
    addRcptProperty () {
      console.log('addRcptProperty called')
    },
    updRcptProperty () {
      console.log('updRcptProperty called')
    },
    delRcptProperty () {
      console.log('delRcptProperty called')
    },
    addRcptComponent () {
      console.log('addRcptComponent called')
    },
    updRcptComponent () {
      console.log('updRcptComponent called')
    },
    delRcptComponent () {
      console.log('delRcptComponent called')
    }
  },

  mounted: function () {
    console.log('views::projectEditor:: mounted with project ', this.project)
  },
  created () {
    console.log('views::projectEditor:: created with project ', this.project)
    this.resetLocal(this.project)
  }
}
</script>
